import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { Fetch } from "../../../shared/Fetch";
import { JVDate } from "../../../shared/JVDate";
import { IUsersDropdown, ICompanyMastDropdown, IBranchMastDropdown, ITeamsDropdown } from "../../../models/IDropdown";
import { JVDropdown } from "../../../shared/JVDropdown";
import { useEffect, useState } from "react";
import { ILogin } from "../../../models/Login";
import { JVCheckbox } from "../../../shared/JVCheckbox";
import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";

export interface ISalRepFilter {
    fromDate?: Date | null,
    toDate?: Date | null,
    company?: number | null,
    branch?: number[] | null,
    team?: number | null,
    salesManager?: number | null,
    isFilter?: number | null,
    requirement_Type?: number | null,
    user_Status?: boolean | null,
    frequency?: number | null,
    exclude_From_Report?: boolean | null,
    agreegate_Report?: boolean | null,
    teamIDs?: number[] | null,
}

export const EmptySalRepFilter: ISalRepFilter = {
    fromDate: new Date,
    toDate: new Date,
    company: null,
    branch: null,
    team: null,
    salesManager: null,
    isFilter: null,
    requirement_Type: null,
    user_Status: null,
    frequency: null,
    exclude_From_Report: null,
    agreegate_Report: null

}

interface Iprops {
    // open: boolean,
    // hideDialog: () => void,
    // toast: any,
    salRepFilter: ISalRepFilter,
    setSalEffFilter: (salEffFilter: ISalRepFilter) => void,
    downloadExcel: (exceltype: number) => Promise<void>,
    excelLoading?: boolean,
    onSearch: () => void
}

export const Filter = (props: Iprops) => {
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [team, setTeam] = useState<Array<ITeamsDropdown>>();
    const [sm, setSM] = useState<Array<IUsersDropdown>>();
    const [excel, setExcel] = useState<boolean>(false);
    const [excelNum, setExcelNum] = useState<number | null>(null);
    const [selectedBranch, setSelectedBranch] = useState<Array<number>>([]);
    const [selectedTeams, setSelectedTeams] = useState<Array<number>>([]);
     const [selectedSm, setselectedSm] = useState<any | null>(null);



    const { control, handleSubmit, reset, watch } = useForm<ISalRepFilter>({
        defaultValues: props.salRepFilter,
        shouldFocusError: false
    });

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const requirement_Status = [
        { requirement_Type: "-- SELECT --", value: 0 },
        { requirement_Type: 'All', value: 1 },
        { requirement_Type: 'Without Float and Global', value: 2 },
        { requirement_Type: 'Float Only', value: 3 },
        { requirement_Type: 'Float All', value: 4 },
        { requirement_Type: 'Global Only', value: 5 },
        { requirement_Type: 'Float and Global', value: 6 }

    ]
    const sales_Status = [
        { label: "-- SELECT --", status: null },
        { label: 'Active', status: true },
        { label: 'Inactive', status: false },
    ]



    const loadBranches = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        let endPoint = loginObj.id === 1346 ? "allBranches" : "reqBranchList";

        const response = await Fetch(`Dropdown/${endPoint}`, "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranches(data);
        }
    };

    const loadCompanies = async () => {
        let endPoint = loginObj.id === 1346 ? "company" : "reqCompanyList";

        const response = await Fetch(`Dropdown/${endPoint}`, "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompanies(data);
        }
    };

    const loadTeam = async (branch: number[] | null | undefined, company: number | null | undefined, type: string = "sales") => {
        let queryParameter = null;
        if (branch && branch.length > 0 && branch[0] != 0) {
            // queryParameter = `branch_ID=${branch}`;
            queryParameter = branch.map(b => `branch_ID=${b}`).join("&");

        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        if (type && type != "" && type != "-- SELECT --") {
            if (type === "sales") queryParameter = "user_Type=sales&" + queryParameter;
            if (type === "recruiter") queryParameter = "user_Type=recruiter&" + queryParameter;
        }

        const response = await Fetch("Dropdown/filterTeamsBranchList", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<ITeamsDropdown> = await response.json();
            const emptyData = {
                team_ID: 0,
                team_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setTeam(data);
        }
    }

    const loadSm = async (branch: number[] | null | undefined, company: number | null | undefined, team: number | null | undefined, teams: number[] | null | undefined) => {
        let queryParameter = null;
        if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        } else if (teams && teams.length > 0 && teams[0] != 0) {
            queryParameter = `&teamIDs=` + teams;
        } else if (branch && branch.length > 0 && branch[0] != 0) {
            // queryParameter = `branch_ID=${branch}`;
            queryParameter = branch.map(b => `branch_ID=${b}`).join("&");

        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        const response = await Fetch("Dropdown/filterUsersListss", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setSM(data);
        }
    }


    const searchToDB = async (body: ISalRepFilter) => {
        // onHide();
        let filterData: any = body;
        let emptyFilter: any = EmptySalRepFilter;
        for (let key in filterData) {
            if (filterData[key] === "-- SELECT --" || filterData[key] === 0) {
                filterData[key] = emptyFilter[key];
            }
        }
        body = filterData;
        props.setSalEffFilter(body);
    }

    // const onHide = () => {
    //     props.hideDialog();
    // }

    function onSubmit(data: ISalRepFilter) {
        console.log(data);
        let newDate = new Date;
        if (data.fromDate?.toDateString() !== newDate.toDateString() || (data.company !== null && data.company !== 0) || (data.branch !== null && selectedBranch.length > 0) || (data.team !== null && data.team !== 0) || (data.salesManager !== null && data.salesManager !== 0)) {
            data.isFilter = 1;
        } else {
            data.isFilter = null;
        }
        if (selectedBranch.length > 0) data.branch = selectedBranch;
        if (selectedTeams.length > 0) data.teamIDs = selectedTeams;
        delete data.frequency;
        searchToDB(data);
        props.onSearch();
    }

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "company") {
                if (value.company != 0 && value.company != null) {
                    loadTeam([], value.company);
                    loadSm([], value.company, 0, []);
                    loadBranches(value.company);
                } else {
                    if (value.company === 0 && value.company != null) {
                        loadBranches();
                        loadTeam(control._formValues.branch, value.company);
                        loadSm(control._formValues.branch, value.company, 0, [control._formValues.team]);
                    }
                }
            }

            if (name === "branch") {
                if (selectedBranch.length > 0 && value.branch != null) {
                    loadTeam([], 0);
                    loadSm([], 0, 0, []);
                } else {
                    if (selectedBranch.length > 0 && value.branch != null) {
                        loadTeam([], control._formValues.company);
                        loadSm([], control._formValues.company, 0, [control._formValues.team]);
                    }
                }
            }

            if (name === "team") {
                if (value.team != 0 && value.team != null) {
                    loadSm([], 0, 0, [value.team]);
                } else {
                    if (value.team === 0 && value.team != null) {
                        loadSm(control._formValues.branch, control._formValues.company, 0, [value.team]);
                    }
                }
            }

            if (name === "frequency") {
                if (value.frequency != 0 && value.frequency != null) {
                    setExcelNum(prev => prev = value?.frequency || 0);
                    setExcel(prev => prev = true);
                } else {
                    setExcel(prev => prev = false);
                    setExcelNum(prev => prev = null);
                }
            }



        });

        return () => subscription.unsubscribe();
    }, [watch]);

    useEffect(() => {
        if (selectedBranch.length > 0) {
            console.log("Selected Branches:", selectedBranch);
            loadTeam(selectedBranch, 0); // Assuming loadTeam takes a single branch
            loadSm(selectedBranch, 0, 0, []); // Pass the entire array
        }
    }, [selectedBranch]);

    useEffect(() => {
        if (selectedTeams.length > 0) {
            loadSm([], 0, 0, selectedTeams); // Pass the entire array
        }
    }, [selectedTeams]);

    useEffect(() => {
        loadTeam([], 0);
        loadSm([], 0, 0, []);
        loadCompanies();
        loadBranches();
    }, []);

    return (
        // <Dialog visible={props.open} style={{ width: '80vw' }} header="Search Sales Report" modal className="p-fluid" onHide={onHide}>
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

            <JVDate maxDate={new Date} column={6} label="From Date" control={control} name="fromDate" />
            <JVDate maxDate={new Date} column={6} label="To Date" control={control} name="toDate" />
            <JVDropdown column={6} label="Company" control={control} name="company" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" />
            {/* <JVDropdown column={6} label="Branch " control={control} name="branch" options={branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch" /> */}
            <div className="field col-2 md:col-2">
                <p>Branch</p>
                <MultiSelect className="" style={{ height: "37px", marginTop: "-10px" }} value={selectedBranch} onChange={(e) => setSelectedBranch(e.value)} options={branches} optionValue="branch_ID" optionLabel="branchName" display="chip" filter placeholder="Select Branches" />
            </div>
            {/* <JVDropdown column={6} label="Team" control={control} name="team" options={team} optionLabel="team_Name" optionValue="team_ID" placeholder="Select Team" /> */}
            <div className="field col-2 md:col-2">
                <p>Teams</p>
                <MultiSelect className="" style={{ height: "37px", marginTop: "-10px" }} value={selectedTeams} onChange={(e) => setSelectedTeams(e.value)} options={team} optionValue="team_ID" optionLabel="team_Name" display="chip" filter placeholder="Select Team" />
            </div>
            <div className="field col-2 md:col-2">
                <p>Sales Manager</p>
                <Dropdown value={selectedSm} style={{ height: "37px", marginTop: "-10px" }} onChange={(e) => { setselectedSm(e.value); }} options={sm} optionLabel="user_Name" placeholder="Select Sales Manager" optionValue="login_ID" filter />
            </div>
            {/* <JVDropdown column={6} label="Sales Manager" control={control} name="salesManager" options={sm} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Sales Manager" /> */}
            <JVDropdown column={6} label="Requirement Type" control={control} name="requirement_Type" options={requirement_Status} optionLabel="requirement_Type" optionValue="value" placeholder="Select Requirement Type " />
            <JVDropdown column={6} label="Sales Status" control={control} name="user_Status" options={sales_Status} optionLabel="label" optionValue="status" placeholder="Select Sales Status" />
            {(_roles.includes(1) || _roles.includes(20) || _roles.includes(26) || _roles.includes(40)) && <JVDropdown column={6} label="Frequency" control={control} name="frequency" options={[{ label: "--SELECT--", value: 0 }, { label: "Daily", value: 4 }, { label: "Weekly", value: 1 }, { label: "Monthly", value: 2 }, { label: "Quarterly", value: 3 }]} optionLabel="label" optionValue="value" placeholder="Select Type Of Excel" />}
            <div className="field col-12 md:col-6">
                <p style={{ color: 'white' }}>.</p>
                <JVCheckbox column={4} label="Show Excluded User" control={control} name="exclude_From_Report" />

            </div>
            <JVCheckbox column={4} label="Combined Report" control={control} name="agreegate_Report" />

            <div style={{ margin: '10px 0', width: '100%' }}></div>

            {/* <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                {!excel && <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>}
                {excel && <Button className="field col-12 md:col-6" loading={props.excelLoading} disabled={props.excelLoading} style={{ backgroundColor: "#9c27b0" }} label="GET EXCEL" onClick={() => { props.downloadExcel(excelNum || 0); }} ></Button>}
                <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={() => { reset(EmptySalRepFilter); setExcel(false); setExcelNum(null); setSelectedBranch([]) }} type="button"></Button>
            </div> */}
            <div className="col-12 md:col-12" style={{ display: "flex", gap: "10px", marginTop: "10px", flexWrap: "nowrap" }}>
                <Button className="field" label="SEARCH" type="submit" style={{ height: "30px" }} />
                {excel && (
                    <Button className="field" loading={props.excelLoading} disabled={props.excelLoading} style={{ backgroundColor: "#9c27b0", height: "30px" }} label="GET EXCEL" onClick={() => { props.downloadExcel(excelNum || 0); }} />)}
                <Button className="field p-button-outlined" label="CLEAR" style={{ height: "30px" }} onClick={() => { reset(EmptySalRepFilter); setExcel(false); setExcelNum(null); setSelectedBranch([]); setselectedSm(null);}} type="button" />
            </div>
        </form>
    );
}
